module.exports = __webpack_public_path__ + "assets/img/bp_d_i_13.f4a12773.jpg";